import { getQuery, postMutation, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { ACCOUNT_MANAGERS } from "src/components/graphql/GraphQLquery";
import { ADD_ACCOUNT_MANAGER, UPDATE_MANAGER } from "src/components/graphql/GraphQLmutation";
import { snackbar } from "@mobiscroll/react5";

export async function addAccountManager(data) {
  try {
    const response = await postMutation(ADD_ACCOUNT_MANAGER, data);

    if (
      typeof response === "undefined" || response?.errors ||
      !(
        response?.data?.addAccountManager?.statusCode < 300 &&
        response?.data?.addAccountManager?.statusCode >= 200
      )
    ) {
      throw new Error("error", response);
    } else {
      snackbar({ message: "Account Added successfully.", color: "success", });
      return true;
    }
  } catch (e) {
    snackbar({ message: "Some error occured while Adding Account. Try again", color: "danger", });
    console.error("Error at addind account manager: ", e);
    return false;
  }
}

export async function allAccountManagers() {
  try {
    const response = await getQuery(ACCOUNT_MANAGERS);

    if (typeof response === "undefined" || response?.errors) {
      throw new Error("error", response)
    } else {
      if (response.data.listAccountManagers.data) {
        snackbar({ message: "Account managers retrieved successfully", color: "success", });
        return response.data.listAccountManagers.data
      } else {
        throw new Error(response)
      }
    }

  } catch (error) {
    snackbar({ message: "Some error occured while fetching. Try again", color: "danger", });
    console.error("Error at getting account managers: ", error);
    return { data: [] };
  }
}


export async function updateManager(data) {
  try {
    const response = await postMutation(UPDATE_MANAGER, data);

    if (
      typeof response === "undefined" || response?.errors ||
      !(
        response?.data?.toggleUserStatus?.statusCode < 300 &&
        response?.data?.toggleUserStatus?.statusCode >= 200
      )
    ) {
      throw new Error("error", response);
    } else {
      snackbar({ message: "Account manager updated successfully.", color: "success", });
      return true;
    }
  } catch (error) {
    snackbar({ message: "Some error occured while updating. Try again", color: "danger", });
    console.error("Error at updating account managers: ", error);
  }
}
